import { scaleQuantile } from 'd3-scale';
import { geoPath, geoConicConformal } from 'd3-geo';

export const generateColorConfig = (limitToggle, colorset) => {
  let domainQuantile;
  let domainLegend;
  let rangeQuantile;
  let steps;

  const [useColors] = colorset;

  const usedUnit =
    limitToggle === 'absolute' ? useColors.absolutUnit : useColors.changeUnit;

  if (limitToggle === 'absolute') {
    domainQuantile = useColors.absolutLimit.split(',').map(Number);
    domainLegend = useColors.absolutLimit.split(',').map(Number);
    rangeQuantile = useColors.absolutColor.split(',');
    steps = useColors.absolutLimit.split(',').map(Number).length;
  } else {
    domainQuantile = useColors.changeLimit.split(',').map(Number);
    rangeQuantile = useColors.changeColor.split(',');
    steps = useColors.changeLimit.split(',').map(Number).length;
    domainLegend = useColors.changeLimit.split(',').map(Number);
  }

  const colorScale = scaleQuantile()
    .domain(domainQuantile)
    .range(rangeQuantile);
  return { domainLegend, rangeQuantile, steps, colorScale, usedUnit };
};

export const buildGeoPath = (shape, width, height, padding) => {
  const projection = geoConicConformal()
    .parallels([35, 65])
    .rotate([-10, 0])
    .fitSize([width - padding * 2, height - padding * 2], shape);

  return geoPath(projection);
};

export const createContourLayerOnChart = (
  shape,
  shapePath,
  defs,
  contourG,
  colors,
  padding
) => {
  defs
    .append('path')
    .attr('class', 'outline')
    .attr('d', shapePath({ type: 'Sphere' }));
  defs
    .append('clipPath')
    .attr('class', 'clip')
    .append('use')
    .attr('href', new URL('#outline', window.location));

  contourG
    .append('path')
    .attr('d', shapePath(shape))
    .style('stroke', colors.themeBase.accentDark)
    .style('stroke-linejoin', 'round')
    .style('stroke-width', '1px')
    .attr('transform', `translate(${padding}, ${padding})`)
    .attr('fill', 'none');
};

export const createDataLayerOnChart = (
  data,
  colorScale,
  pixelG,
  padding,
  shapePath
) => {
  pixelG.attr('transform', `translate(${padding}, ${padding})`);
  const rectData = [];
  data.forEach((entry) => {
    rectData.push({
      type: 'LineString',
      coordinates: entry.corners,
      extras: {
        value: entry.value,
      },
    });
  });

  pixelG
    .selectAll('path')
    .data(rectData)
    .enter()
    .append('path')
    .attr('class', 'route')
    .attr('d', shapePath)
    .attr('value', (d) => d.extras.value)
    .style('fill', (d) => colorScale(d.extras.value))
    .style('shape-rendering', 'crispedges');
};

export const mapDataToShape = (dataArray, coordinates) => {
  const array = dataArray.map((obj) => {
    const element = coordinates[obj.y][obj.x];
    switch (obj.x) {
      case 1:
        return {
          corners: [element.tl, element.tr, element.br, element.bl],
          value: obj.value,
        };
      case 0:
        return null;
      default:
        return {
          corners: [
            coordinates[obj.y][obj.x - 1].tr,
            element.tr,
            element.br,
            coordinates[obj.y][obj.x - 1].br,
          ],
          value: obj.value,
        };
    }
  });
  return array.filter((obj) => obj);
};

export const extractActiveShape = (fullShape) => {
  const finalShape = JSON.parse(
    JSON.stringify(fullShape)
  );
  finalShape.geometry.coordinates[0].reverse();
  return finalShape;
};
